import React, { FC } from 'react';
import { getEnvironment } from '@minecraft.environment';

const environment = getEnvironment();
const cldDomain = environment.CLD_DOMAIN;

type CloudinaryDocumentDownloadProps = {
  linkText?: string;
  fileKey?: string;
  cloudName?: string;
  customComponent?: ({ url }) => JSX.Element;
  isVideoSnapshot?: boolean;
  snapShotStartOffset?: string;
};

const CloudinaryDocumentDownload: FC<CloudinaryDocumentDownloadProps> = ({
  linkText,
  fileKey,
  cloudName,
  customComponent: CustomLink,
  isVideoSnapshot = false,
  snapShotStartOffset,
}) => {
  const snapshotOffset = snapShotStartOffset ? `/so_${snapShotStartOffset}/` : '/';

  const cloudinaryDownloadUrl = isVideoSnapshot
    ? `https://${cldDomain}/${cloudName}/video/upload${snapshotOffset}f_jpg/fl_attachment/${fileKey}`
    : `https://${cldDomain}/${cloudName}/image/upload/fl_attachment/${fileKey}`;

  return (
    <>
      {CustomLink ? (
        <CustomLink url={cloudinaryDownloadUrl} />
      ) : (
        <a href={cloudinaryDownloadUrl}>{linkText || 'Download'}</a>
      )}
    </>
  );
};

export default CloudinaryDocumentDownload;
